/**
 * @spec docs/specs/features/staking-position-ui.md#framework-portability-patterns
 * Environment variable wrapper for framework portability
 *
 * Single source of truth for all environment variables.
 * To migrate to Next.js: only change this file to use process.env.NEXT_PUBLIC_*
 */

export const env = {
  // Privy Configuration
  privyAppId: (() => {
    switch (import.meta.env.VITE_ENVIRONMENT) {
      case 'prod':
        return 'clvwrzvit049tejn7zkksautg';
      case 'staging':
        return 'clvl2h3t4009z4zhrp83gopvn';
      case 'dev':
        return 'clvwrwuyh01tzt3q7h7wdixq1';
      default:
        // on our local, to test privy tokens we default to production privy app id
        return 'clvwrzvit049tejn7zkksautg';
    }
  })(),

  // Data Sources
  stakingIndexerUrl: import.meta.env.VITE_STAKING_INDEXER_URL,
  rewardsApiUrl: import.meta.env.VITE_REWARDS_API_URL,
  claimApiUrl: import.meta.env.VITE_CLAIM_API_URL,
  walletRelationsApiUrl: import.meta.env.VITE_WALLET_RELATIONS_API_URL,
  swapApiUrl: import.meta.env.VITE_SWAP_API_URL,

  // Blockchain RPCs
  baseRpcUrl: import.meta.env.VITE_BASE_RPC_URL,
  polygonRpcUrl: import.meta.env.VITE_POLYGON_RPC_URL,

  // Block Explorers
  baseExplorerUrl: import.meta.env.VITE_BASE_EXPLORER_URL,
  polygonExplorerUrl: import.meta.env.VITE_POLYGON_EXPLORER_URL,

  // Contract Addresses (Base Mainnet)
  contracts: {
    phnmTokenAddress: import.meta.env.VITE_PHNM_TOKEN_ADDRESS,
    stakingAddress: import.meta.env.VITE_STAKING_ADDRESS,
    claimAddress: import.meta.env.VITE_CLAIM_ADDRESS,
    usdtRedemptionAddress: import.meta.env.VITE_USDT_REDEMPTION_ADDRESS,
    swapRelayerAddress: import.meta.env.VITE_SWAP_RELAYER_ADDRESS,
    usdcTokenAddress: import.meta.env.VITE_USDC_TOKEN_ADDRESS,
  },

  // Token Configuration (environment-specific)
  // Dev/testnet may use 18 decimals for USDT, production uses 6
  usdtDecimals: parseInt(import.meta.env.VITE_USDT_DECIMALS || '6', 10),
};

// Runtime validation - warn about missing required variables
const requiredVars = {
  VITE_PRIVY_APP_ID: env.privyAppId,
  VITE_STAKING_INDEXER_URL: env.stakingIndexerUrl,
  VITE_REWARDS_API_URL: env.rewardsApiUrl,
  VITE_CLAIM_API_URL: env.claimApiUrl,
};

Object.entries(requiredVars).forEach(([key, value]) => {
  if (!value) {
    console.warn(`⚠️  Missing required environment variable: ${key}`);
  }
});

// Optional variables (nice to have)
const optionalVars = {
  VITE_BASE_RPC_URL: env.baseRpcUrl,
  VITE_POLYGON_RPC_URL: env.polygonRpcUrl,
  VITE_SWAP_API_URL: env.swapApiUrl,
};

Object.entries(optionalVars).forEach(([key, value]) => {
  if (!value) {
    console.info(`ℹ️  Optional environment variable not set: ${key}`);
  }
});
